<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <dashboard-review-claims-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ReviewClaims',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    DashboardReviewClaimsView: () => import('../components/dashboards/ReviewClaimsView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
